export type ThemeMode = "light" | "dark" | "system";
export type ResolvedThemeMode = "light" | "dark";

export const THEME_STORAGE_KEY = "diecastshowcase_theme";
export const THEME_CHANGE_EVENT = "diecastshowcase:themeChanged";

function isBrowser() {
  return typeof window !== "undefined";
}

export function getTheme(): ThemeMode {
  if (!isBrowser()) {
    return "system";
  }

  const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (storedTheme === "light" || storedTheme === "dark" || storedTheme === "system") {
    return storedTheme;
  }

  return "system";
}

export function resolveTheme(theme: ThemeMode = getTheme()): ResolvedThemeMode {
  if (!isBrowser()) {
    return "light";
  }

  if (theme === "light" || theme === "dark") {
    return theme;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyThemeClass(resolvedTheme: ResolvedThemeMode) {
  if (!isBrowser()) {
    return;
  }

  const root = window.document.documentElement;
  root.classList.toggle("dark", resolvedTheme === "dark");
  root.dataset.theme = resolvedTheme;
}

export function setTheme(theme: ThemeMode) {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  const resolved = resolveTheme(theme);
  applyThemeClass(resolved);
  window.dispatchEvent(
    new CustomEvent(THEME_CHANGE_EVENT, {
      detail: {
        theme,
        resolvedTheme: resolved,
      },
    }),
  );
}

export function initTheme() {
  if (!isBrowser()) {
    return;
  }

  const theme = getTheme();
  applyThemeClass(resolveTheme(theme));
}

